import React, { useState } from "react";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { toast } from "sonner";

export const WishlistButton = ({ productId, className = "", size = 18 }) => {
  const { user, isWished, toggleWishlist, openAuth, apiError } = useAuth();
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const wished = isWished(productId);

  const click = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!user) { openAuth("login"); return; }
    setBusy(true);
    try {
      const wl = await toggleWishlist(productId);
      toast.success(wl.includes(productId) ? t("added_wishlist") : t("removed_wishlist"));
    } catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };

  return (
    <button onClick={click} disabled={busy} data-testid={`wishlist-btn-${productId}`}
      aria-label="wishlist"
      className={`grid place-items-center rounded-full transition-colors ${className}`}>
      <Heart style={{ width: size, height: size }} className={wished ? "fill-mango-600 text-mango-600" : "text-stone-500"} />
    </button>
  );
};
